// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WarehouseList_pageWrap__O0Xpo {
  padding: 4px 4px 32px;
}

.WarehouseList_filterField__uEqSy {
  display: flex;
  align-items: center;
  gap: 10px;
}

.WarehouseList_filterLabel__35T3K {
  font-size: 12.5px;
  font-weight: 700;
  color: #6B7280;
  white-space: nowrap;
}

.WarehouseList_sellerSelect__gvfWj {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 180px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.WarehouseList_sellerSelect__gvfWj:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.WarehouseList_warehouseName__To2pm {
  color: #1F2430;
  font-weight: 700;
  font-family: 'Sora', 'Inter', sans-serif;
}

.WarehouseList_warehouseCode__bT7gq {
  font-size: 11.5px;
  color: #9CA3AF;
  margin-top: 2px;
}

/* =========================================================
   View-details modal
   ========================================================= */
.WarehouseList_modalBox__UsPit {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
}

.WarehouseList_modalHeader__ePZNq {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
}

.WarehouseList_modalTitle__24k4r {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.WarehouseList_modalClose__mPCsZ {
  color: #ffffff;
  cursor: pointer;
  display: flex;
}

.WarehouseList_modalBody__G45UE {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.WarehouseList_detailGrid__areqi {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.WarehouseList_detailRow__cN86M {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #F1F2F6;
}
.WarehouseList_detailRow__cN86M:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.WarehouseList_detailLabel__UhBbZ {
  font-size: 11.5px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

.WarehouseList_detailValue__yny42 {
  font-size: 13.5px;
  color: #1F2430;
  text-align: right;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Warehouse/WarehouseList.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.filterField {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filterLabel {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #6B7280;\n  white-space: nowrap;\n}\n\n.sellerSelect {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 180px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.sellerSelect:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.warehouseName {\n  color: #1F2430;\n  font-weight: 700;\n  font-family: 'Sora', 'Inter', sans-serif;\n}\n\n.warehouseCode {\n  font-size: 11.5px;\n  color: #9CA3AF;\n  margin-top: 2px;\n}\n\n/* =========================================================\n   View-details modal\n   ========================================================= */\n.modalBox {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n}\n\n.modalTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.modalClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n}\n\n.modalBody {\n  padding: 20px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.detailGrid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detailRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #F1F2F6;\n}\n.detailRow:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.detailLabel {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n}\n\n.detailValue {\n  font-size: 13.5px;\n  color: #1F2430;\n  text-align: right;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `WarehouseList_pageWrap__O0Xpo`,
	"filterField": `WarehouseList_filterField__uEqSy`,
	"filterLabel": `WarehouseList_filterLabel__35T3K`,
	"sellerSelect": `WarehouseList_sellerSelect__gvfWj`,
	"warehouseName": `WarehouseList_warehouseName__To2pm`,
	"warehouseCode": `WarehouseList_warehouseCode__bT7gq`,
	"modalBox": `WarehouseList_modalBox__UsPit`,
	"modalHeader": `WarehouseList_modalHeader__ePZNq`,
	"modalTitle": `WarehouseList_modalTitle__24k4r`,
	"modalClose": `WarehouseList_modalClose__mPCsZ`,
	"modalBody": `WarehouseList_modalBody__G45UE`,
	"detailGrid": `WarehouseList_detailGrid__areqi`,
	"detailRow": `WarehouseList_detailRow__cN86M`,
	"detailLabel": `WarehouseList_detailLabel__UhBbZ`,
	"detailValue": `WarehouseList_detailValue__yny42`
};
export default ___CSS_LOADER_EXPORT___;
